import React ,{useState,useRef} from 'react'
import "../pesquisarcliente.css";
import ReactToPrint from 'react-to-print';
import axios from 'axios';
import {ComponentToPrint} from './Print';
import ReactToExcel from 'react-html-table-to-excel';
import { AreaChart,LineChart, Line ,Tooltip,CartesianGrid,XAxis,YAxis, Area,ResponsiveContainer} from 'recharts';
import parseISO from 'date-fns/parseISO';
import subDays from 'date-fns/subDays';
import format from 'date-fns/format';
import { DeleteOutline } from '@material-ui/icons';
import {toast,ToastContainer} from 'react-toastify';
import { set } from 'date-fns';
import moment from 'moment';
import { Row, Col, Input,Divider, Typography,Select,Form,Button,Modal,DatePicker,Space,Table} from 'antd';
import {ExclamationOutlined ,InfoCircleOutlined ,SearchOutlined,PrinterOutlined,FileExcelOutlined } from '@ant-design/icons';
toast.configure()
const { Option } = Select;
function Pesquisarcliente() {
    const [dados,setDados]=useState({nrcliente:"",nome:"",bi:"",nuit:"",morada:"",email:"",telemovel:""});
    const [metern,setMetern]=useState({novom:''});
    const [novo,setnovoM]=useState("");
    const [metodoFilter, setMetodoFilter] = useState(null);
    const [ant,setantM]=useState("");
    const [diaanofim,setDianofim]=useState(new Date());
    const [meter,setMeter]=useState();
    const [apanhado,setApanhado]=useState(null);
    const [token,setToken]=useState(null);
    const [tokens,setTokens]=useState(null);
    const printContent = useRef(null);
    const printContents = useRef(null);
    const printReclama=useRef(null);
    const tableRef= useRef(null);
    const printChart=useRef(null);
    const [medias,setMedias]=useState(null);
    const [Data,setData]=useState("");
    const [m,setm]=useState("");
    const [md,setmd]=useState("");
    const [estemeter,setEstemeter]=useState(null);
    const [estadod,setEstadod]=useState("");
    const [eliminar,setEliminar]=useState(null);
    const [diaano,setDiaAno]=useState(new Date());
    const [Reclama,setReclamacao]=useState(null);
    const [request,setRequest]=useState(null);
    const [error,setError]=useState(null);
    const [detalhes,setDetalhes]=useState(null);
    const [reclama,setReclama]=useState(null);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    const [visible, setVisible] = useState(false);

    const showModal = () => {
        setVisible(true);
    };

    const handleOk = () => {
        setVisible(false);
    };

    const handleCancel = () => {
        setVisible(false);
    };
    const MetUpdate=()=>{
        axios({
            method:"post",
            url:`${localStorage.getItem('url')}/web/ActualizeContadores/`,
            headers:{'Authorization':`token ${localStorage.getItem('token')}`,'Content-Type':'application/json' },
            data:{id:dados.nrcliente,idContadornovo:novo,cintador_ant:ant}
        }).then(dat=>{ if(dat.status!==200){
            throw Error('Dados de acesso invalidos');  
                }
            return dat
         } ).then( d=>{
            toast.success('Contador Actualizado com Sucesso')
            setm(null);
        }
       
           ).catch(e=>{
            toast.error('Selecione os contadores que deseja actualizar')
     
       })
    
    }
    const ClieUpdate=()=>{
        axios({
            method:"post",
            url:`${localStorage.getItem('url')}/web/updatecliente/`,
            headers:{'Authorization':`token ${localStorage.getItem('token')}`,'Content-Type':'application/json' },
            data:dados
        }).then(dat=>{ if(dat.status!==200){
            throw Error('Dados de acesso invalidos');  
                }
            return dat
         } ).then( d=>{
            toast.success('Cliente Actualizado com Sucesso')
            setm(null);
        }
       
           ).catch(e=>{
            setError(e.message );
        })
    
    }
    const handleChange = (e) => {
      const { name, value } = e.target;
      console.log(name,value)
      setDados({
        ...dados,
        [name]: value
      });
    };
  
    const Tokens_recargas=()=>{
        console.log('===============================')
        axios({
            method:"post",
            url:`${localStorage.getItem('url')}/web/TokensRecarga`,
            headers:{'Authorization':`token ${localStorage.getItem('token')}`,'Content-Type':'application/json' },
            data:{id:dados.nrcliente}
        }).then(dat=>{ if(dat.status!==200){
            throw Error('Dados de acesso invalidos');  
                }
            return dat
         } ).then( d=>{
            console.log('sdsdsdsdssds')
            console.log(d.data);
            setTokens(d.data)
        }
       
           ).catch(e=>{
            setError(e.message );
        })
    
    }
    const delH=e=>{
        e.preventDefault()
        DeleteU()
    }
    const Medias=()=>{
        axios({
            method:"post",
            url:`${localStorage.getItem('url')}/web/MediaCompraRecarga`,
            headers:{'Authorization':`token ${localStorage.getItem('token')}`,'Content-Type':'application/json' },
            data:{id:dados.nrcliente}
        }).then(dat=>{ if(dat.status!==200){
            throw Error('Dados de acesso invalidos');  
                }
            return dat
         } ).then( d=>{
            console.log(d.data);
            setMedias(d.data);
        }
       
           ).catch(e=>{
            setError(e.message );
        })
    
    }
    const Pesquisar=()=>{
        axios({
            method:"post",
            url:`${localStorage.getItem('url')}/web/clieantefind/`,
            headers:{'Authorization':`token ${localStorage.getItem('token')}`,'Content-Type':'application/json' },
            data:{id:dados.nrcliente}
        }).then(dat=>{ if(dat.status!==200){
            throw Error('Dados de acesso invalidos');  
                }
            return dat
         } ).then( d=>{
            console.log(dados);
            dados.nome=d.data.nome;
            dados.nuit=d.data.nuit;
            dados.bi=d.data.bi;
            dados.email=d.data.email;
            dados.morada=d.data.morada;
            dados.telemovel=d.data.telemovel;
            setApanhado("sds");
         }
       
           ).catch(e=>{
            setError(e.message );
        })
    
    }
    const Todosmd=()=>{
        axios({
            method:"post",
            url:`${localStorage.getItem('url')}/web/TodosCDisponiveis/`,
            headers:{'Authorization':`token ${localStorage.getItem('token')}`,'Content-Type':'application/json' },
            data:{id:dados.nrcliente}
        }).then(dat=>{ if(dat.status!==200){
            throw Error('Dados de acesso invalidos');  
                }
            return dat
         } ).then( d=>{
            console.log(d.data);
            setmd(d.data);
         }
       
           ).catch(e=>{
            setError(e.message );
        })
    
       
    }
    const met=()=>{
        axios({
            method:"post",
            url:`${localStorage.getItem('url')}/web/listacontadores/`,
            headers:{'Authorization':`token ${localStorage.getItem('token')}`,'Content-Type':'application/json' },
            data:{id:dados.nrcliente}
        }).then(dat=>{ if(dat.status!==200){
            throw Error('Dados de acesso invalidos');  
                }
            return dat
         } ).then( d=>{
            console.log(d.data);
            
            setm(d.data);
            
         }
       
           ).catch(e=>{
            setError(e.message );
        })
    
        
    }
    const ADD=()=>{
        axios({
            method:"post",
            url:`${localStorage.getItem('url')}/web/AdicionarMeter/`,
            headers:{'Authorization':`token ${localStorage.getItem('token')}`,'Content-Type':'application/json' },
            data:{id:dados.nrcliente,meter:estemeter}
        }).then(dat=>{ if(dat.status!==200){
            throw Error('Dados de acesso invalidos');  
                }
            return dat
         } ).then( d=>{
            toast.success('Adiconado com Sucesso')
            setm(null);
        }
       
           ).catch(e=>{
            setError(e.message );
            toast.erro('Adiconado sem Sucesso')
        })
    
        
    }
    const ADDHandler=e=>{
        e.preventDefault();
        ADD();
    }
    const VerContadores=()=>{
        axios({
            method:"post",
            url:`${localStorage.getItem('url')}/web/listacontadores/`,
            headers:{'Authorization':`token ${localStorage.getItem('token')}`,'Content-Type':'application/json' },
            data:{id:dados.nrcliente}
        }).then(dat=>{ if(dat.status!==200){
            throw Error('Dados de acesso invalidos');  
                }
            return dat
         } ).then( d=>{
            console.log(d.data);
            setMeter(d.data);
         }
       
           ).catch(e=>{
            setError(e.message );
        })
    
        
    }
    const excelExport=()=>{
        tableRef.current.save();
    }
    const Enviar=()=>{
        axios({
            method:"post",
            url:`${localStorage.getItem('url')}/web/enviarfactura/`,
            headers:{'Authorization':`token ${localStorage.getItem('token')}`,'Content-Type':'application/json' },
            data:{id:dados.nrcliente,tef:dados.telemovel,email:dados.email}
        }).then(dat=>{ if(dat.status!==200){
            throw Error('Dados de acesso invalidos');  
                }
            return dat
         } ).then( d=>{
            console.log(d.data);
     
         }
       
           ).catch(e=>{
            setError(e.message );
        })
    
       
    }
 
    const DeleteU=()=>{
        axios({
            method:"post",
            url:`${localStorage.getItem('url')}/web/DeleteUser`,
            headers:{'Authorization':`token ${localStorage.getItem('token')}`,'Content-Type':'application/json' },
            data:{id:dados.nrcliente}
        }).then(dat=>{ if(dat.status!==200){
            throw Error('Dados de acesso invalidos');  
                }
            return dat
         } ).then( d=>{
            setMedias(null)
            setMeter(null);
            setToken(null);
            setReclama(null);
            setDetalhes(null);
            setRequest(null);
            setApanhado(null);     
            
            toast.success(`Usuario Eliminado com sucesso!`);
            setEliminar(null);
        }
       
           ).catch(e=>{
            setError(e.message );
        })
    
    
    }
    const Reclamacoes=()=>{
        axios({
            method:"post",
            url:`${localStorage.getItem('url')}/web/ClienteReclamacoes`,
            headers:{'Authorization':`token ${localStorage.getItem('token')}`,'Content-Type':'application/json' },
            data:{id:dados.nrcliente}
        }).then(dat=>{ if(dat.status!==200){
            throw Error('Dados de acesso invalidos');  
                }
            return dat
         } ).then( d=>{
            console.log(d.data);
            setReclamacao(d.data);
         }
       
           ).catch(e=>{
            setError(e.message );
        })
    
        
    
    }
   
    
    const Handler=e=>{
        e.preventDefault();
        Pesquisar();
       
    }
    const Contadores=e=>{
        e.preventDefault();
        setMedias(null)
        setEliminar(null);
        setVisible(true)
        setmd(null);
        setRequest(null);
        setReclama(null)
        setToken(null);
        setDetalhes(null);
        VerContadores();
        setm(null)
    }
    const THandler=e=>{
        e.preventDefault();
        setMedias(null)
        setEliminar(null);
        setVisible(true)
        setm(null)
        setmd(null);
        setMeter(null);
        setRequest(null);
        setReclama(null)
        setDetalhes(null);
        setToken("sdsd");
        Tokens_recargas();
        
    }
    const Send=e=>{
        e.preventDefault();
        Enviar();
    }
    const uCHanddler=e=>{
        e.preventDefault();
        ClieUpdate();
    }
    const uMHandler=e=>{
        e.preventDefault();
        MetUpdate();
    }
    const UHandler=e=>{
        e.preventDefault();
        setm(null)
        setMedias(null)
        setEliminar(null);
        setVisible(true)
        Todosmd();
        setmd(null);
        setMeter(null);
        setToken(null);
        setReclama(null);
        setDetalhes(null);
        setm('23s')

        setRequest('ddfd');       
       
    }
    const RHsandler=e=>{
        e.preventDefault();
        setm(null)
        setVisible(true)
        setEliminar(null);
        setMedias(null)
        setmd(null);
        setMeter(null);
        setRequest(null);
        setReclama(null)
        setToken(null);
        setDetalhes(null);
        setReclama("sdsdd")
        Reclamacoes();
     
    }
    const DelHandler=e=>{
        e.preventDefault();
        setm(null)
        setEliminar(null);
        
        
        setmd(null);
        setMedias(null)
        setMeter(null);
        setRequest(null);
        setReclama(null)
        setToken(null);
        setDetalhes(null);
        setReclama(null)
        setEliminar('dfd');
     
    }
    const Mudar=e=>{
        e.preventDefault();
        setm(null)
        setVisible(true)
        setEliminar(null);
        setMeter(null);
        setRequest(null);
        setReclama(null);
        setmd(null);
        setToken(null);
        setReclama(null);
        setDetalhes("sdsd");
        Medias();
    }

    const Search=(row)=>{
       
        return row.filter((row)=>
        row.metodo.toLowerCase().indexOf(Data)>-1)
    }
    const SearchD=(row)=>{
        let idado=new Date(diaano)
    let fdados=new Date (diaanofim)
    idado=idado.getTime()
    fdados=fdados.getTime()
    console.log(idado)
    console.log(fdados)
    return row.filter((row)=>
    idado<=(new Date(row.data_de_compra)).getTime() && (new Date(row.data_de_compra)).getTime() <=fdados);
        
    }
    const SearchR=(row)=>{
       
        return row.filter((row)=>
        row.data_de_compra.toLowerCase().indexOf(diaano)>-1)
    }
    const CalcularMedia=(row)=>{
        let avarage=0
        for(let i=0;i<row.length;i++){
            let cur= parseFloat(row[i].valor_pago)
            avarage=avarage+cur
        } 
        console.log(row.length)
        console.log(avarage)
        
        avarage=avarage/row.length;
        avarage=avarage.toFixed(2)
        return avarage   
    }
    const CalcularSoma=(row)=>{
        let avarage=0
        for(let i=0;i<row.length;i++){
            let cur= parseFloat(row[i].valor_pago)
            avarage=avarage+cur
        } 
       return avarage
    }
    const CalcularIva=(row)=>{
        let avarage=0
        for(let i=0;i<row.length;i++){
            let cur= parseFloat(row[i].iva)
            avarage=avarage+cur
        } 
       return avarage.toFixed(3)
    }
    const CalcularTsc=(row)=>{
        let avarage=0
        for(let i=0;i<row.length;i++){
            let cur= parseFloat(row[i].tsc)
            avarage=avarage+cur
        } 
       return avarage.toFixed(3)
    }
    const column_meters = [
        {
          title: 'Numero do Contador',
          dataIndex: 'numero_do_contador',
          key: 'numero_do_contador',
        },
        {
          title: 'Ano do TID',
          dataIndex: 'tid',
          key: 'tid',
        },
        {
          title: 'Latitude',
          dataIndex: 'lat',
          key: 'lat',
        },
        {
          title: 'Longitude',
          dataIndex: 'lon',
          key: 'lon',
        },
        {
          title: 'Data de Instalacao',
          dataIndex: 'data_instalacao',
          key: 'data_instalacao',
        },
        {
          title: 'Meter Care',
          key: 'meter_care',
          render: () => (
            <Button >Acessar</Button>
          ),
        },
        {
          title: 'Ultima manutencao',
          key: 'ultima_manutencao',
          render: () => (
            <Button >Detalhes</Button>
          ),
        },
        {
          title: 'Meter Info',
          key: 'meter_info',
          render: () => (
            <Button >Detalhes</Button>
          ),
        },
      ];
      const columns_tokens = [
        {
          title: "Nome",
          dataIndex: "nome",
          key: "nome",
          render: (text, record) => dados.nome,
        },
        {
          title: "Numero de Contador",
          dataIndex: "numero_contador",
          key: "numero_contador",
        },
        {
          title: "Token",
          dataIndex: "numero_token",
          key: "numero_token",
        },
        {
          title: "Valor Pago",
          dataIndex: "valor_pago",
          key: "valor_pago",
        },

        {
          title: "Metros cubicos",
          dataIndex: "metroscubicos",
          key: "metroscubicos",
        },
        {
          title: "Metodo de Pagamento",
          dataIndex: "metodo",
          key: "metodo_pagamento",
          filterDropdown: ({
            setSelectedKeys,
            selectedKeys,
            confirm,
            clearFilters,
          }) => (
            <div style={{ padding: 8 }}>
              <Select
                allowClear
                style={{ width: "100%", marginBottom: 8, display: "block" }}
                placeholder="Select Metodo de Pagamento"
                value={selectedKeys[0]}
                onChange={(value) => setSelectedKeys(value ? [value] : [])}
              >
                <Option value="Mpesa">M-PESA</Option>
                <Option value="emola">E-MOLA</Option>
                <Option value="RecargaAKI">RecargaAKI</Option>
                <Option value="CONTA MOVEL">CONTA MOVEL</Option>
                <Option value="OPERADOR">OPERADOR</Option>
              </Select>
              <Button
                type="primary"
                onClick={() => handleSearch(selectedKeys, confirm)}
                icon={<SearchOutlined />}
                size="small"
                style={{ width: 90, marginRight: 8 }}
              >
                Search
              </Button>
              <Button
                onClick={handleReset(clearFilters)}
                size="small"
                style={{ width: 90 }}
              >
                Reset
              </Button>
            </div>
          ),
          filterIcon: (filtered) => (
            <SearchOutlined
              style={{ color: filtered ? "#1890ff" : undefined }}
            />
          ),
          filteredValue: [metodoFilter],
          onFilter: (value, record) => {
            if (!value) return true; // If no filter value selected, show all records
            return record.metodo.indexOf(value) !== -1;
          },
        },

        ,

        // Other columns...
        {
            title: "Data de Geracao",
            dataIndex: "data_de_compra",
            key: "data_de_compra",
          },
      ];
    const handleSearchd = (selectedKeys, confirm) => {
        console.log('dfdf')
        console.log(selectedKeys)
        confirm();
       
    };
    const handleSearch = (selectedKeys, confirm) => {
        confirm();
        setMetodoFilter(selectedKeys[0]);
    };

    const handleReset = (clearFilters) => () => {
        clearFilters();
        setStartDate(null);
        setEndDate(null);
        setMetodoFilter(null);
    };  

    return (
      <form className="ClienteSS">
        <div className="separador"></div>
        <div className="procurarss">
          <Input
            name="numero de contador"
            type="number"
            autoComplete="off"
            onChange={(e) => setDados({ ...dados, nrcliente: e.target.value })}
            value={dados.nrcliente}
            placeholder="Enter client number"
            suffix={
              <Button type="primary" onClick={Handler}>
                Search
              </Button>
            }
          />
        </div>
        {apanhado && (
          <div className="">
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item label="Nome">
                  <Input value={dados.nome} disabled />
                </Form.Item>
                <Form.Item label="NUIT">
                  <Input value={dados.nuit} disabled />
                </Form.Item>
                <Form.Item label="BI">
                  <Input value={dados.bi} disabled />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Morada">
                  <Input value={dados.morada} disabled />
                </Form.Item>
                <Form.Item label="Email">
                  <Input value={dados.email} disabled />
                </Form.Item>
                <Form.Item label="Telemovel">
                  <Input value={dados.telemovel} disabled />
                </Form.Item>
              </Col>
            </Row>
          </div>
        )}

        {apanhado && (
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
              marginTop: "3%",
            }}
          >
            <Button onClick={Contadores}>Contadores</Button>
            <Button onClick={THandler}>Recargas</Button>
            <Button onClick={UHandler}>Actualizar dados</Button>
            <Button icon={<ExclamationOutlined />} onClick={RHsandler}>
              Reclamacoes
            </Button>
            <Button icon={<InfoCircleOutlined />} onClick={Mudar}>
              Detalhes
            </Button>
          </div>
        )}
        <Modal
          title=""
          visible={visible}
          onOk={handleOk}
          onCancel={handleCancel}
          width={"90%"}
        >
          {meter && (
            <div className="">
              <Table columns={column_meters} dataSource={meter} />
            </div>
          )}

          {meter && (
            <div className="clienteaccoes">
              <Button onClick={Send} icon={<PrinterOutlined />}>
                Imprimir
              </Button>
              <Button icon={<FileExcelOutlined />}>Exportar</Button>
            </div>
          )}

          {token && (
            <div className="">
              <Table dataSource={tokens} columns={columns_tokens} bordered />
            </div>
          )}

          {token && (
            <div className="clienteaccoes">
              <Button onClick={Send} icon={<PrinterOutlined />}>
                Imprimir
              </Button>
              <Button icon={<FileExcelOutlined />}>Exportar</Button>
            </div>
          )}

          {m && (
            <>
              {apanhado && (
                <div className="">
                  <Row gutter={16}>
                    <Col span={12}>
                    <Form.Item label="Nome">
          <Input name="nome" value={dados.nome} onChange={handleChange} />
        </Form.Item>
        <Form.Item label="NUIT">
          <Input name="nuit" value={dados.nuit} onChange={handleChange} />
        </Form.Item>
        <Form.Item label="BI">
          <Input name="bi" value={dados.bi} onChange={handleChange} />
        </Form.Item>
                    </Col>
                    <Col span={12}>
                    <Form.Item label="Morada">
          <Input name="morada" value={dados.morada} onChange={handleChange} />
        </Form.Item>
        <Form.Item label="Email">
          <Input name="email" value={dados.email} onChange={handleChange} />
        </Form.Item>
        <Form.Item label="Telemovel">
          <Input name="telemovel" value={dados.telemovel} onChange={handleChange} />
        </Form.Item>
                    </Col>
                  </Row>
                </div>
              )}
            </>
          )}

          {m && (
            <div>
              {md && (
                <div>
                  <Space>
                    <Button onClick={uCHanddler}>
                      Atualizar Dados Básicos
                    </Button>
                  </Space>
                </div>
              )}
            </div>
          )}
          {md && <Divider />}
          {md && <Divider />}

          {md && (
            <Space direction="vertical">
              <div className="casa_nova">NovoMeter</div>
              <Select
                id="combosa"
                maxTagCount={3}
                maxMenuHeight={250}
                onChange={(value) => setEstemeter(value)}
                placeholder="Selecione um contador"
              >
                {md.map((ct, key) => (
                  <Select.Option key={ct.idContador} value={ct.idContador}>
                    {ct.numero_do_contador}
                  </Select.Option>
                ))}
              </Select>
              <Button onClick={ADDHandler}>Adicionar Contador</Button>
            </Space>
          )}

          {reclama && (
            <>
              <div >
                <Table
                  id="tabela-Reclamacao"
                  dataSource={Reclama}
                  pagination={false}
                >
                  <Table.Column
                    title="Nome do Cliente"
                    dataIndex="nome"
                    key="nome"
                  />
                  <Table.Column
                    title="Data De Submissao"
                    dataIndex="datahora"
                    key="datahora"
                  />
                  <Table.Column
                    title="Codigo de Erro"
                    dataIndex="diagnostco_tecnico"
                    key="diagnostco_tecnico"
                  />
                  <Table.Column
                    title="Descricao da Falha"
                    dataIndex="descricao"
                    key="descricao"
                  />
                  <Table.Column
                    title="Necessidade de Operario"
                    dataIndex="Necesse"
                    key="Necesse"
                  />
                  <Table.Column
                    title="Estado"
                    dataIndex="Estado"
                    key="Estado"
                  />
                  <Table.Column title="Imagem" dataIndex="foto" key="foto" />
                  <Table.Column
                    title="Numero de Contador"
                    dataIndex="numero_do_contador"
                    key="numero_do_contador"
                  />
                  <Table.Column
                    title="Tempo de Resposta"
                    key="tempo_resposta"
                    render={() => "3 horas"}
                  />
                  <Table.Column
                    title="Data de Resolucao"
                    dataIndex="datahora"
                    key="data_resolucao"
                  />
                </Table>
              </div>
              <Divider />
              <div className="clienteaccoes">
                <Button  onClick={Send}>
                  Imprimir
                </Button>
                <Button  onClick={Send}>
                  Exportar
                </Button>
              </div>
            </>
          )}

{medias && (
  <>
    <div className="colunad">
      <div className="linhas">
        <div id="icon">
          <img id="imagem" src={require("./images/flame.png")} />
        </div>
        <div id="text">
          Total: {CalcularSoma(SearchD(medias))} Mzn
        </div>
      </div>
      <div className="linhas">
        <div id="icon">
          <img id="imagem" src={require("./images/vat (1).png")} />
        </div>
        <div id="text">
          Total IVA: {CalcularIva(SearchD(medias))} Mzn
        </div>
      </div>
      <div className="linhas">
        <div id="icon">
          <img id="imagem" src={require("./images/token.png")} />
        </div>
        <div id="text">
          Total TSC: {CalcularTsc(SearchD(medias))} Mzn
        </div>
      </div>
      <div className="linhas">
        <div id="icon">
          <img id="imagem" src={require("./images/tax.png")} />
        </div>
        <div id="text">
          Media Das Compras: {CalcularMedia(SearchD(medias))} Mzn
        </div>
      </div>
    </div>
    <ResponsiveContainer width="100%" height={200} className="casa">
      <AreaChart data={SearchD(medias)}>
        <defs>
          <linearGradient id="color" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#053f40" stopOpacity={0.4}></stop>
            <stop offset="75%" stopColor="#053f40" stopOpacity={0.05}></stop>
          </linearGradient>
        </defs>
        <Area dataKey="valor_pago" stroke="#053f40" fill="url(#color)" />
        <XAxis
          dataKey="data_de_compra"
          axisLine={false}
          tickLine={false}
          tickFormatter={(str) => {
            const date = parseISO(str);
            if (date.getDate() % 7 === 0) {
              return format(date, "MMM, d");
            }
            return "";
          }}
        />
        <Tooltip />
        <YAxis
          dataKey="valor_pago"
          axisLine={false}
          tickLine={false}
          tickCount={8}
          tickFormatter={(number) => `$${number.toFixed(2)}`}
        />
        <CartesianGrid opacity={0.1} vertical={false} />
      </AreaChart>
    </ResponsiveContainer>
    <Divider />
  </>
)}

{detalhes && (
  <div className="clienteaccoes">
    <Button  onClick={Send}>Imprimir</Button>
    <Button >Exportar</Button>
    <Button  onClick={Send}>Filtros</Button>
    <DatePicker onChange={(date, dateString) => setDiaAno(dateString)} />
    <Typography.Text>Fim</Typography.Text>
    <DatePicker onChange={(date, dateString) => setDianofim(dateString)} />
  </div>
)}

{eliminar && (
  <div className="Sistema">
    <div id="icon">
      <img id="imagem" src={require("./images/gears copy.png")} />
    </div>
    <div id="texts">
      <Typography.Title level={3}>MOZAMBIQUE PREPAYMENT SYSTEM</Typography.Title>
      <Typography.Title level={4}>
        Deseja Eliminar Permanentemente o usuário Número de Cliente: {dados.nrcliente}?
      </Typography.Title>
      <Typography.Text type="danger">Esta ação é irreversível</Typography.Text>
    </div>
    <Button id="opcao" value="Nao" onClick={delH}>Eliminar</Button>
  </div>
)}
        </Modal>
      </form>
    );
}

export default Pesquisarcliente
